export const THEME_IDS = {
  DEFAULT: 'default',
  BIG_TOP: 'big-top',
};
